import { yy } from "../../../i18n/en";

export default {
    environmentInfo: {
        pm25: 10,
        temperature: 31,
        humidity: 60,
        pm: 35,
        co2: 25
    },
    overviewInfo: {
        area: 22344,
        rentalArea: 15435,
        occupancyRate: 52,
        vacancyRate: 48
    },
    enterprise: {
        register: 3430,
        enter: 2430,
        type: [
            {
                "value": 32,
                "name": "High pay"
            },
            {
                "value": 12,
                "name": "Unicorn"
            },
            {
                "value": 5,
                "name": "Star"
            },
            {
                "value": 23,
                "name": "List"
            },
            {
                "value": 35,
                "name": "Gazelle"
            },
            {
                "value": 12,
                "name": "On gauge"
            }
        ],
        industry: [
            {
                "value": 34,
                "name": "Materials"
            },
            {
                "value": 12,
                "name": "LED"
            },
            {
                "value": 24,
                "name": "Electric"
            },
            {
                "value": 65,
                "name": "Communicate"
            },
            {
                "value": 23,
                "name": "Flat Panel"
            },
            {
                "value": 34,
                "name": "Software"
            }
        ],
    },
    facility: {
        cameraOnline: 31,
        cameraOffline: 3,
        cameraAlarm: 4,
        totalParking: 345,
        remainCar: 54,
        bayonet: ['正常', '拥堵', '一般'],

    },
    light: [
        {
            "region": "办公区",
            "workStatus": "正常",
            "workTime": "2376 h",
            "maintain": 43,
            "alarm": 54
        },
        {
            "region": "商业区",
            "workStatus": "正常",
            "workTime": "565 h",
            "maintain": 23,
            "alarm": 31
        },
        {
            "region": "健身区",
            "workStatus": "异常",
            "workTime": "234 h",
            "maintain": 12,
            "alarm": 14
        },
        {
            "region": "居住区",
            "workStatus": "正常",
            "workTime": "1565 h",
            "maintain": 31,
            "alarm": 35
        },
        {
            "region": "车库",
            "workStatus": "正常",
            "workTime": "546 h",
            "maintain": 15,
            "alarm": 22
        }
    ],
    energy: {
        water: 1454,
        ele: 4323,
        grade: 'A 级',
        todayEnergy: '1234 kw',
        time: ['一月', '二月', '三月', '四月', '五月', '六月'],
        ele: [50, 60, 60, 71, 65, 58],
        eleRatio: [120, 134, 156, 161, 144, 134],
        waterRatio: [263, 254, 216, 181, 174, 154],
    },

    caraccess: {
        name: [yy.$yy_r3_name1, yy.$yy_r3_name2]
    }

};
